var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinaryTeamCommissionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.866,
    height: 44.793,
    viewBox: "0 0 44.866 44.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team-svgrepo-com",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 4.424,
    cy: 4.424,
    r: 4.424,
    transform: "translate(2.706 0.1)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M2.194,42.658h.439v8.776a2.2,2.2,0,0,0,2.194,2.194H9.434a2.2,2.2,0,0,0,2.194-2.194v-.512a5.546,5.546,0,0,1-.658-2.56V36.881a5.472,5.472,0,0,1,3.291-5.01v-.878A2.2,2.2,0,0,0,12.067,28.8H2.194A2.2,2.2,0,0,0,0,30.994v9.471A2.177,2.177,0,0,0,2.194,42.658Z",
    transform: "translate(0 -18.206)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 4.424,
    cy: 4.424,
    r: 4.424,
    transform: "translate(33.348 0.1)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M83.7,30.894v.878a5.472,5.472,0,0,1,3.291,5.01V48.226a5.136,5.136,0,0,1-.658,2.56V51.3a2.2,2.2,0,0,0,2.194,2.194h4.607A2.2,2.2,0,0,0,95.327,51.3V42.522h.438a2.2,2.2,0,0,0,2.194-2.194V30.894A2.2,2.2,0,0,0,95.766,28.7H85.893A2.2,2.2,0,0,0,83.7,30.894Z",
    transform: "translate(-53.094 -18.142)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M39.1,47.094h0V58.575a2.2,2.2,0,0,0,2.194,2.194h.841V71.117a2.2,2.2,0,0,0,2.194,2.194h5.887a2.2,2.2,0,0,0,2.194-2.194V60.733h.841a2.2,2.2,0,0,0,2.194-2.194V47.094h0A2.2,2.2,0,0,0,53.251,44.9H41.294A2.177,2.177,0,0,0,39.1,47.094Z",
    transform: "translate(-24.803 -28.418)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 5.083,
    cy: 5.083,
    r: 5.083,
    transform: "translate(17.369 4.488)",
    fill: "#3d3d3d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinaryTeamCommissionsIcon);
export default __webpack_public_path__ + "static/media/binary-team-commissions-icon.718de1cc89ce42aa2077365c719465c9.svg";
export { ForwardRef as ReactComponent };